import {type ReactNode} from 'react'
import {cn} from '~/design-system/utils'

type HgWYSIWYGContainerProps = {
  children: ReactNode
  className?: string
}

const HgWYSIWYGContainer = ({children, className}: HgWYSIWYGContainerProps) => {
  return (
    <div
      className={cn(
        'col-span-full grid w-full grid-cols-subgrid lg:row-start-1 [&_ol_+_ul]:my-4 md:[&_ol_+_ul]:my-8 lg:[&_ol_+_ul]:my-12',
        className
      )}
    >
      {children}
    </div>
  )
}

export default HgWYSIWYGContainer
